module.exports = require("@mario-kart/domain").RaceRotator;
